import * as __au2ViewDef from './my-app.html';
import { IRouter, IRouteableComponent } from '@aurelia/router';
import { IAppService } from './services/app';

import './assets/qce/qce2_ischeme.css';
import './assets/styles/styles.css';
import './assets/styles/application.css';

import AppLogo from './assets/icons/header-logo.png';
import FooterLogo from './assets/icons/footer-logo.png';
import { watch, customElement } from '@aurelia/runtime-html';

@customElement(__au2ViewDef)
export class MyApp implements IRouteableComponent {
    protected currentYear: number;
    protected helpHtml = '';
    protected appLogo = AppLogo;
    protected footerLogo = FooterLogo;

    static routes = [
        {
            path: ':schemeGuid/:sessionId?',
            component: () => import('./modules/wizard/steps'),
            title: 'Steps',
        },
        {
            path: 'complete',
            component: () => import('./modules/complete/complete'),
            title: 'Quote Completed',
        },
        {
            path: ['', 'error/:errorCode?'],
            component: () => import('./modules/error/error'),
            title: 'Error Occurred',
        },
    ];

    constructor(
        @IAppService readonly appService: IAppService,
        @IRouter readonly router: IRouter
    ) {
        const d = new Date();

        this.currentYear = d.getFullYear();
    }

    attached() {
        this.popupOpen();

        this.helpHtml = this.appService.scheme.helpHtml;
    }

    @watch((model: MyApp) => model.appService.scheme.helpHtml)
    updateHelpHtml() {
        this.helpHtml = this.appService.scheme.helpHtml;
    }

    // On click of .popup-add get its content and insert into mobile popup box.
    popupOpen() {
        if (window.innerWidth < 980) {
            const mobilePopup = document.getElementById('mobile-popup');
            const mobilePopupAdds =
                document.getElementsByClassName('popup-add');

            for (let i = 0; i < mobilePopupAdds.length; i++) {
                const mobilePopupAdd = mobilePopupAdds[i];

                mobilePopupAdd.addEventListener('click', function () {
                    const mobilePopupContent = this.outerHTML;
                    mobilePopup.innerHTML = mobilePopupContent;

                    const popupTitle =
                        mobilePopup.getElementsByTagName('h2')[0];
                    popupTitle.innerHTML =
                        popupTitle.innerHTML + '<span id="popup-close"></span>';
                    mobilePopup.classList.add('active');

                    const closePopup = document.getElementById('popup-close');

                    if (closePopup) {
                        closePopup.addEventListener('click', () => {
                            mobilePopup.classList.remove('active');
                            mobilePopup.firstChild.remove();
                        });
                    }
                });
            }
        }
    }
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = MyApp;

    // @ts-ignore
    const proto = MyApp.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }